import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const getAreaList = (params, options) =>
  request.get(
    '/api/blade-system/region/lazy-tree',
    Object.assign({}, options, { params })
  );
  
  export const getServiceProjectPage = (params, options) =>
  request.get(
    '/api/v4ward/out/order/service/item/page',
    Object.assign({}, options, { params })
  );

  export const getCommunityListPage = (params, options) =>
  request.get(
    '/api/v4ward/out/order/service/community/page',
    Object.assign({}, options, { params })
  );

  export const getScoreListPage = (params, options) =>
  request.get(
    '/api/v4ward/out/order/service/integral/record/page',
    Object.assign({}, options, { params })
  );

  export const serviceItemPage = (params, options) =>
  request.get(
    '/api/nursing/serviceItem/page',
    Object.assign({}, options, { params })
  );

  export const serviceItemDetail = (params, options) =>
  request.get(
    '/api/nursing/serviceItem/detail',
    Object.assign({}, options, { params })
  );
  export const serviceItemSave= (params, options) =>
  request.post('/api/nursing/serviceItem/save', params, options);

  
  export const serviceItemUpdate= (params, options) =>
  request.post('/api/nursing/serviceItem/update', params, options);

  export const serviceItemRemove= (id) =>
  request.post('/api/nursing/serviceItem/remove?ids='+id);

  //明细查询
  export const serviceItemList = (params, options) =>
  request.get(
    '/api/nursing/serviceItemList/page',
    Object.assign({}, options, { params })
  );
//明细新增
export const serviceItemListSave= (params, options) =>
request.post('/api/nursing/serviceItemList/save', params, options);

//明细查询
export const serviceItemListDetail = (params, options) =>
request.get(
  '/api/nursing/serviceItemList/detail',
  Object.assign({}, options, { params })
);
//明细修改
export const serviceItemListUpdate= (params, options) =>
request.post('/api/nursing/serviceItemList/update', params, options);

export const serviceItemListRemove= (id) =>
request.post('/api/nursing/serviceItemList/remove?ids='+id);
  export const nursingDetail = (params, options) =>
  request.get(
    '/api/nursing/detail',
    Object.assign({}, options, { params })
  );
//明细修改
export const stockWarnSave= (params, options) =>
request.post('/api/nursing/registration/save', params, options);

//明细修改
export const stockWarnUpdate= (params, options) =>
request.post('/api/nursing/registration/update', params, options);

//明细修改
export const stockWarnDelete= (id) =>
request.post('/api/nursing/registration/remove?ids='+id);

//明细查询
export const getNursinghome = (params, options) =>
request.get(
  '/api/nursing/getNursinghome',
  Object.assign({}, options, { params })
);

//明细查询
export const getNursinghomePage = (params, options) =>
request.get(
  '/api/nursing/basicInfor/page',
  Object.assign({}, options, { params })
);



//明细修改
export const saveCommunityInfo= (params, options) =>
request.post('/api/v4ward/out/order/service/community/save', params, options);


//明细修改
export const saveBasicInfo= (params, options) =>
request.post('/api/nursing/basicInfor/submit', params, options);

//明细修改
export const saveProviderInfo= (params, options) =>
request.post('/api/v4ward/out/service/provider/save', params, options);

//明细修改
export const updateProviderInfo= (params, options) =>
request.post('/api/v4ward/out/service/provider/update', params, options);

//明细修改
export const saveProviderUserInfo= (params, options) =>
request.post('/api/v4ward/out/service/provider/user/save', params, options);

//明细修改
export const updateProviderUserInfo= (params, options) =>
request.post('/api/v4ward/out/service/provider/user/update', params, options);



//明细修改
export const submitServiceInfo= (params, options) =>
request.post('/api/v4ward/out/service/provider/submitItem', params, options);

//明细修改
export const getProviderServiceList= (params, options) =>
request.get(
  '/api/v4ward/out/service/provider/optional/item/list',
  Object.assign({}, options, { params })
);

//明细修改
export const getProviderServiceItemList= (params, options) =>
request.get(
  '/api/v4ward/out/service/provider/item/list',
  Object.assign({}, options, { params })
);

//明细修改
export const getProviderList= (params, options) =>
request.get(
  '/api/v4ward/out/service/provider/list',
  Object.assign({}, options, { params })
);
//明细修改
export const getProviderUserList= (params, options) =>
request.get(
  '/api/v4ward/out/service/provider/user/page',
  Object.assign({}, options, { params })
);



//明细修改
export const getCommunityList= (params, options) =>
request.get(
  '/api/v4ward/out/order/service/community/list',
  Object.assign({}, options, { params })
);





//明细修改
export const saveServiceProjectBasicInfo= (params, options) =>
request.post('/api/v4ward/out/order/service/item/save', params, options);


//明细修改
export const updateServiceProjectBasicInfo= (params, options) =>
request.post('/api/v4ward/out/order/service/item/update', params, options);

//明细修改
export const updateServiceProjectStatus= (params, options) =>
request.post('/api/v4ward/out/order/service/item/updateStatus', params, options);

//明细查询
export const getServiceProviderPage = (params, options) =>
request.get(
  '/api/v4ward/out/service/provider/page',
  Object.assign({}, options, { params })
);

//明细查询
export const getServiceProjectDetail = (params, options) =>
request.get(
  '/api/v4ward/out/order/service/item/detail',
  Object.assign({}, options, { params })
);


//明细修改
export const saveFamilyMember= (params, options) =>
request.post('/api/nursing/familyMember/submit', params, options);

//明细查询
export const getFamilyMemberPage = (params, options) =>
request.get(
  '/api/nursing/familyMember/page',
  Object.assign({}, options, { params })
);

//明细修改
export const saveHealthInfo= (params, options) =>
request.post('/api/nursing/health/submit', params, options);

//明细修改
export const saveMedicalTestInfo= (params, options) =>
request.post('/api/nursing/physical/submit', params, options);

//明细修改
export const saveCateringBedInfo= (params, options) =>
request.post('/api/nursing/cateringBed/submit', params, options);

//明细修改
export const basicInforRemove= (id) =>
request.post('/api/nursing/basicInfor/remove?ids='+id);

//明细查询
export const getHealthPageDetail = (params, options) =>
request.get(
  '/api/nursing/health/detail',
  Object.assign({}, options, { params })
);

//明细查询
export const getPhysicalDetail = (params, options) =>
request.get(
  '/api/nursing/physical/detail',
  Object.assign({}, options, { params })
);

//明细查询
export const getCateringBedDetail = (params, options) =>
request.get(
  '/api/nursing/cateringBed/detail',
  Object.assign({}, options, { params })
);

//明细修改
export const familyMemberRemove= (id) =>
request.post('/api/nursing/familyMember/remove?ids='+id);

//明细查询
export const getBedTypeList = (params, options) =>
request.get(
  '/api/nursing/bed/type/list',
  Object.assign({}, options, { params })
);

//明细查询
export const getDeviceTypePage = (params, options) =>
request.get(
  '/api/nursing/deviceType/page',
  Object.assign({}, options, { params })
);


//明细修改
export const saveDeviceType= (params, options) =>
request.post('/api/nursing/deviceType/save', params, options);

//明细修改
export const deviceTypeRemove= (id) =>
request.post('/api/nursing/deviceType/remove?ids='+id);

//明细查询
export const getDeviceModelList = (params, options) =>
request.get(
  '/api/nursing/deviceModel/modellist',
  Object.assign({}, options, { params })
);

//明细查询
export const getDeviceModelPage = (params, options) =>
request.get(
  '/api/nursing/deviceModel/page',
  Object.assign({}, options, { params })
);

//明细查询
export const getDeviceTypeList = (params, options) =>
request.get(
  '/api/nursing/deviceType/typelist',
  Object.assign({}, options, { params })
);

//明细查询
export const getPartnerList = (params, options) =>
request.get(
  '/api/nursing/partner/partnerlist',
  Object.assign({}, options, { params })
);

//明细修改
export const saveDeviceModel= (params, options) =>
request.post('/api/nursing/deviceModel/save', params, options);

//明细修改
export const deviceModelRemove= (id) =>
request.post('/api/nursing/deviceModel/remove?ids='+id);

//明细查询
export const getWristbandPage = (params, options) =>
request.get(
  '/api/nursing/wristband/page',
  Object.assign({}, options, { params })
);

//明细查询
export const getNursingList = (params, options) =>
request.get(
  '/api/nursing/basicInfor/nursinglist',
  Object.assign({}, options, { params })
);

//明细修改
export const saveWristband= (params, options) =>
request.post('/api/nursing/wristband/save', params, options);

//明细修改
export const wristbandRemove= (id) =>
request.post('/api/nursing/wristband/remove?ids='+id);

//明细查询
export const getEventsPage = (params, options) =>
request.get(
  '/api/nursing/events/page',
  Object.assign({}, options, { params })
);

//明细修改
export const saveEvents= (params, options) =>
request.post('/api/nursing/events/save', params, options);

//明细修改
export const updateEvents= (params, options) =>
request.post('/api/nursing/events/update', params, options);

//明细修改
export const eventsRemove= (id) =>
request.post('/api/nursing/events/remove?ids='+id);

//明细查询
export const getEventsDetail = (params, options) =>
request.get(
  '/api/nursing/events/detail',
  Object.assign({}, options, { params })
);

//明细查询
export const getBasicInforDetail = (params, options) =>
request.get(
  '/api/nursing/basicInfor/detail',
  Object.assign({}, options, { params })
);

//明细修改
export const updateDeviceType= (params, options) =>
request.post('/api/nursing/deviceType/update', params, options);


//明细修改
export const updateDeviceModel= (params, options) =>
request.post('/api/nursing/deviceModel/update', params, options);

//明细修改
export const updateWristband= (params, options) =>
request.post('/api/nursing/wristband/update', params, options);

//明细查询
export const deviceStart = (params, options) =>
request.get(
  '/api/nursing/wristband/start',
  Object.assign({}, options, { params })
);

//明细查询
export const deviceStop = (params, options) =>
request.get(
  '/api/nursing/wristband/stop',
  Object.assign({}, options, { params })
);

//明细查询
export const treeNursingList = (params, options) =>
request.get(
  '/api/nursing/common/tree-Nursing-list',
  Object.assign({}, options, { params })
);
//状态
export const updateUserStatus= (params, options) =>
request.post('/api/v4ward/out/service/provider/user/updateStatus', params, options);

//明细查询
export const treeListDetail = (params, options) =>
request.get(
  '/api/nursing/bed/detail',
  Object.assign({}, options, { params })
);
//明细查询
export const getServiceStatistic = (params, options) =>
request.get(
  '/api/v4ward/out/service/provider/settlement/getServiceStatistic',
  Object.assign({}, options, { params })
);

//明细查询
export const getOutOrderServiceStatistic = (params, options) =>
request.get(
  '/api/v4ward/out/order/getOutOrderServiceStatistic',
  Object.assign({}, options, { params })
);
//明细查询
export const getSettlementList = (params, options) =>
request.get(
  '/api/v4ward/out/service/provider/settlement/page',
  Object.assign({}, options, { params })
);

//明细修改
export const updateSettlement= (params, options) =>
request.post('/api/v4ward/out/service/provider/settlement/update', params, options);

//明细修改
export const updateServiceCommunity= (params, options) =>
request.post('/api/v4ward/out/order/service/community/update', params, options);

//明细修改
export const removeServiceCommunity= (id) =>
request.post('/api/v4ward/out/order/service/community/remove?ids='+id);
// request.post('/api/v4ward/out/order/service/community/remove', params, options);

//明细查询
export const getServiceProviderDetail = (params, options) =>
request.get(
  '/api/v4ward/out/service/provider/detail',
  Object.assign({}, options, { params })
);

//明细查询
export const getServiceProviderUserDetail = (params, options) =>
request.get(
  '/api/v4ward/out/service/provider/user/detail',
  Object.assign({}, options, { params })
);


//明细修改
export const updateProviderStatus= (params, options) =>
request.post('/api/v4ward/out/service/provider/updateStatus', params, options);


// 获取部门树
export const getDeptTreeApi = (params, options) =>
  request.get('/api/base/deptproperty/tree', Object.assign({}, options, { params }));
  

//明细修改
export const saveScoreSetting= (params, options) =>
request.post('/api/v4ward/out/order/service/integral/setting/submit', params, options);

//明细修改
export const getScoreSettingDetail= (params, options) =>
request.get('/api/v4ward/out/order/service/integral/setting/detail', Object.assign({}, options, { params }));


  